import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { getListCSBO, Filteroptions, SessionFormSaveBO, EmitBo, EngagementSaveBO, ClientTabBO, Authpopup, ClientAuthforSessionBO, functionpermission} from './consultation-services.modal';
import { GlobalComponent } from 'src/app/global/global.component';
import { ConsultationServices } from './consultation-services.service';
import { Observable, Subject } from 'rxjs';
import { retry, takeUntil } from 'rxjs/operators';
import { columnWidth } from '../employee/employee.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ElementSchemaRegistry } from '@angular/compiler';
import { CommonApiService } from 'src/app/commonapiservice';
import { Guid } from '@syncfusion/ej2/pdf-export';
@Component({
  selector: 'app-consultation-services',
  templateUrl: './consultation-services.component.html',
  styleUrls: ['./consultation-services.component.scss']
})
export class ConsultationServicesComponent implements OnInit {
  @ViewChild('pdfViewer') pdfViewer;
  CSBO: getListCSBO = new getListCSBO();
  startmin: string = "";
  @Input() csform: ClientTabBO;
  public selectionOptions: SelectionSettingsModel;
  CSDataList: any = [];
  FilterStartDate: any = "";
  FilterEndDate: any = ""
  StartDate: any = "";
  EndDate: any = ""
    fp: functionpermission = new functionpermission();
  OngoingList: any = [];
  QualityAssuranceList: any = [];
  ServiceSetupList: any = [];
  ClientList: any = "";
  SSSlist: any = [];
  OASlist: any = [];
  Olist: any = [];
  ConsultantList: any = "";
  @ViewChild('gridCS') public gridCS: GridComponent;
  saveBo: EngagementSaveBO = new EngagementSaveBO();
  public GridDataCS: Observable<DataStateChangeEventArgs>;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  arraycol: any = [];
  ColumnArray: columnWidth[];
  filterOptions: FilterSettingsModel;
  datetimeformat: object;
  dateformat: object;
  isOngoing: boolean = false;
  isQAL: boolean = false;
  isSSL: boolean = false;
  ContactList: any = [];
  clientFirstName: any = "";
  clientLastname: any = "";
  clientMiddlename: any = "";
  isContactOtherDes: boolean = false;
  SessionDate: any = "";
isClientEligible: boolean = true;
showEligibilityMessage: boolean = false;
clientId :string;
  loggedInEmployeeId: string = null;
isEmployeeDisabled: boolean = false;
  ServiceList: any = [
    // {
    //   "id":"1",
    //   "serviceCode":"Service setup and annual CFSS orientation"
    // },
    // {
    //   "id":"2",
    //   "serviceCode":"Quality assurance support"
    // },
    // {
    //   "id":"3",
    //   "serviceCode":"Ongoing consultation and skill development"
    // }
  ];
  duration: any;
  UserDropDownList: any;
  pdfBase64: any;
  @ViewChild("PdfList") PdfList;
  sessionDeleteId: string;
  saveFormBo: SessionFormSaveBO = new SessionFormSaveBO();
  viewPdfFOrm: boolean = false
  EmitToChildBo: EmitBo = new EmitBo();
  private onDestroy$: Subject<void> = new Subject<void>();
  EngagementList: any = [];
  viewpdf : boolean = false;
  popupmsg : string;
  popupbo : Authpopup = new Authpopup();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  ClientAuthforSessionBO:ClientAuthforSessionBO=new ClientAuthforSessionBO();
  viewsession : boolean = true;
  viewsessionpdf : boolean = false;
  isViewMode: boolean = false;
  currentViewData: any = null;
  checktypeofcontact : any;
  ConsultSessionTotalColumns:number=11;
  constructor(public CommonAPI: CommonApiService,private ngxService: NgxUiLoaderService,
    private http: HttpClient,
    public datepipe: DatePipe, public dateservice: DateService, public global: GlobalComponent, public CSService: ConsultationServices, private toastrService: ToastrService , public CommonApi : CommonApiService,
  private cdRef: ChangeDetectorRef) {
    this.GridDataCS = this.CSService
  }
  ngOnInit(): void {
    this.clearGridLocalStorage();
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.startmin = this.global.getDateTimeString(new Date()).replace("Z", "");
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.datetimeformat = {
      type: "datetime",
      format: "MM/dd/yyyy h:mm:ss a",
    };
    this.dateformat = {
      type: "date",
      format: "MM/dd/yyyy",
    };

   
    this.GetOngoing()
    this.getQualityAssuranceSupport()
    this.GetServiceSetup()
    this.GetContactType();
    this.GetAllClientDropDown();
    this.GetUserDropDownList();
    if(this.csform?.ClientId!=undefined&& this.csform?.ClientId!=null && this.csform?.ClientId!="")
    {
      this.FilterStartDate=null;
        this.FilterEndDate=null;
    }
    else{
      this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    }
    this.getCSListFilter();
    this.GetServiceType();
    this.getpermission();

  }
  public dataStateChange(state): void {
    let type: String = (state.action.requestType).toString();
    this.CSBO.currentpageno = this.gridCS.pagerModule.pagerObj.currentPage;
    this.CSBO.pageitem = this.gridCS.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.CSBO.orderColumn = state.sorted[0].name;
        this.CSBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      this.CSBO.currentpageno = 1;
      this.CSBO.pageitem = 10;
      if (this.CSBO.type == "date") {
        this.CSBO.value = (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      }
      else {
        this.CSBO.value = state.action.currentFilterObject.value
      }
      this.CSBO.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isClientSign") {
        this.CSBO.value = this.CSBO.value == 'Yes' ? 'true' : 'false';
        this.CSBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "isEmployeeSign") {
        this.CSBO.value = this.CSBO.value == 'Yes' ? 'true' : 'false';
        this.CSBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.CSBO.field = "timesheetStatus"
        this.CSBO.type = "string";
      }
      if (state.action.currentFilterObject.field == "totalHours") {
        this.CSBO.value = this.CSBO.value.toString();
      }
      // if (state.action.currentFilterObject.field == "dailyAuthorizedhours") {
      //   this.CSBO.value = this.CSBO.value.toString();
      // }
      this.CSBO.operator = state.action.currentFilterObject.operator;
    }
    if (state.action.requestType == "filtering" && state.action.action == "clearFilter") {
      this.CSBO.currentpageno = 1;
      this.CSBO.pageitem = 10;
      this.CSBO.operator = "contains"
      this.CSBO.type = "string";
      this.CSBO.value = "";
      this.CSBO.field = "clientName";
      this.CSBO.orderColumn = "clientName";
      this.CSBO.orderType = 'ASC';
    }
    if (state.action.requestType != "refresh") {
      this.getCSListFilter();
    }

  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridCS.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].EVV_Timesheet.ShowColumns?.length != count1 || this.arraycol[0].EVV_Timesheet.HideColumns?.length != count) {
            this.arraycol[0].EVV_Timesheet.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }

      }
    }
    if (args.requestType == "filterafteropen") {
      this.CSBO.type = args.columnType;
    }
  }
  GetAllClientDropDown() {
    let url = "";
    if (this.global.OnboardType == "CLIENT") {
      url = "api/ConsultationSession/GetAllClientDropDown?";
    }
    else {
      url = "api/Client/GetAllClientDropDown?";
    }

    this.CSService.GetAllClientDropDown(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientList = data;
      if (this.global.OnboardType == "CLIENT") {
        this.saveBo.clientId = this.ClientList?.filter(cli => cli.Key == this.global.cfssLoginEntityId)[0]?.Key;
        // this.GetServiceType();
        this.GetClientPmi()
      }
      if (this.csform?.ClientId != null && this.csform?.ClientId != undefined && this.csform?.ClientId != "") {
        this.saveBo.clientId = this.ClientList?.filter(cli => cli.Key == this.csform.ClientId)[0]?.Key;
        // this.GetServiceType();
        this.GetClientPmi()
      }

    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  GetConsultantDropDown() {
    let url = "";
    if (this.global.OnboardType == "CLIENT") {
      url = "api/ConsultationSession/GetAllClientDropDown?";
    }
    else {
      url = "api/Client/GetAllClientDropDown?";
    }

    this.CSService.GetConsultantDropDown(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ConsultantList = data;
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  GetUserDropDownList() {
    this.CSService.GetUserDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UserDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }

  editSession(data) {

    document.getElementById("openSessionModal").click();
    // this.EmitToChildBo.EngagementId = data.id
    // this.EmitToChildBo.sessionFormId = data.sessionFormId
    // this.EmitToChildBo.FormTemplateId = data.sessionFormTempleteId
    // this.EmitToChildBo.isChild = true;
    // this.EmitToChildBo.isUpdateForm = true;

    this.GetSpecificEngagementDetails(data);

  }
  editData(data) {
    this.clientFirstName = data.clientFirstName;
    this.clientMiddlename = data.clientMiddlename;
    this.clientLastname = data.clientlastname;

  }
  getCSListFilter() {
    if (this.global.OnboardType == "CLIENT") {
      this.CSBO.clientId = this.global.cfssLoginEntityId;
    }
    else if (this.csform != null) {
      this.CSBO.clientId = this.csform.ClientId;
    }
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.CSBO.startDate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeString(SDate) : null

    this.CSBO.endDate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeString(EDate) : null
    this.CSService.outputValues(this.CSBO)
    let count = 0;
    this.GridDataCS.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.CSDataList = data.result;

      this.ngxService.stop()
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result?.length > 15) {
          this.gridCS.height = '500';
        }
        else {
          this.gridCS.height = 'auto';
        }
      }
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        //this.getColumnwidth()
      }
    }
    )
  }
  Refresh() {
       if(this.csform?.ClientId!=undefined&& this.csform?.ClientId!=null && this.csform?.ClientId!="")
    {
      this.FilterStartDate=null;
        this.FilterEndDate=null;
    }
    else{
      this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    }
    this.CSBO = new getListCSBO();

    this.getCSListFilter();
    this.clearEngagement();
    // this.GetAllClientDropDown();
    // this.GetUserDropDownList();
  }
  clearEngagement() {
    this.saveBo = new EngagementSaveBO();
    this.StartDate = ""; this.EndDate = "";
    this.isSSL = false; this.isQAL = false; this.isOngoing = false;
    this.ServiceSetupList = JSON.parse(JSON.stringify(this.SSSlist));
    this.QualityAssuranceList =JSON.parse(JSON.stringify(this.OASlist));
    this.OngoingList =JSON.parse(JSON.stringify(this.Olist));
    this.duration = null;
    this.startmin = this.global.getDateTimeString(new Date()).replace("Z", "");
    this.isClientEligible = true;
    this.isEmployeeDisabled=false;
  }
  show() {
    this.gridCS.columnChooserModule.openColumnChooser(500, -250); // give X and Y axis
  }
  hourscalculation() {
    if (
      this.StartDate != null &&
      this.EndDate != null &&
      this.StartDate != "" &&
      this.EndDate != ""
    ) {
      if (
        new Date(this.StartDate).getTime() <= new Date(this.EndDate).getTime()
      ) {
        let start = new Date(this.StartDate).getTime();
        let end = new Date(this.EndDate).getTime();
        let diff = end - start;

        var hours = Math.floor(diff / 1000 / 60 / 60);
        diff -= hours * 1000 * 60 * 60;
        var minutes = Math.floor(diff / 1000 / 60);
        if (minutes <= 7) {
          minutes = 0;
        } else if (minutes <= 22) {
          minutes = 25;
        } else if (minutes <= 37) {
          minutes = 50;
        } else if (minutes <= 52) {
          minutes = 75;
        } else {
          minutes = 0;
          hours += 1;
        }
        let durationHours = hours + "." + minutes;
        this.duration = hours + "." + minutes;
        this.saveBo.duration = parseFloat(durationHours)
           this.checkValidation();
      } else {
        let dateError = "End time should greater than start time";
        this, this.saveBo.duration = 0;
        this.toastrService.error(dateError, "Error")
        setTimeout(() => {
          dateError = ""
        }, 2000);
      }
    }
  }
  getDeleteId(data) {
    this.sessionDeleteId = data.id;
    document.getElementById("openSessionDelete").click();
  }
  deleteSessionEngagement() {
    let params = new URLSearchParams();
    params.append("EngagementId", this.sessionDeleteId);
    this.CSService.deleteSessionEngagement(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Session Deleted Successfully");
      this.sessionDeleteId = null;
      document.getElementById("openSessionDelete").click();
      this.getCSListFilter();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.error, " Error");
        setTimeout(() => {
          this.toastrService.clear();
        }, 2000);
      })
  }
  ParentToChild(event: EmitBo) {
    this.EmitToChildBo = event;
    document.getElementById("openPDFModal").click();
    this.getCSListFilter();
  }
  checkTime() {
    if (
      new Date(this.StartDate).getTime() > new Date(this.EndDate).getTime()
    ) {
      this.toastrService.error("end time should greater than start time");
      setTimeout(() => {
        this.toastrService.clear();
      }, 2000);
      return;
    }
    else {
      this.SaveManualEngagement();

    }
  }
  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == 'StartDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterStartDate = val1;

        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterEndDate = val1;
        }
      }
    }

    if (type == "datechanged") {
      if (name == 'StartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterStartDate = val1;
          this.clearTimeValidation();
        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterEndDate = val1;
          this.clearTimeValidation();
        }
      }
    }
  }
  clearTimeValidation(){
    if(this.csform?.ClientId == undefined || this.csform?.ClientId == null || this.csform?.ClientId == ""){
      if (this.FilterEndDate != null && this.FilterEndDate != undefined && this.FilterEndDate != '') {
        if (new Date(this.FilterStartDate).getTime() > new Date(this.FilterEndDate).getTime()) {
          this.FilterEndDate = null;
          this.toastrService.error("End date should be greater than the start date");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
      if (
      this.FilterStartDate &&this.FilterEndDate) {
          const startDate = new Date(this.FilterStartDate);
          const endDate = new Date(this.FilterEndDate);
          let setDate = startDate.setDate(startDate.getDate() + 365);
          let getDate = setDate;
          let ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
      if (new Date(endDate).getTime() > new Date(ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.FilterEndDate = null;
        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);
      }
    }
  }
  }
  contactTypeChange() {
    let contactDetails = this.ContactList?.filter(a => a.id == this.saveBo.typeofContactId)[0]
    if (contactDetails?.lovName?.toUpperCase() == "OTHER") {
      this.isContactOtherDes = true;
    }
    else {
      this.isContactOtherDes = false;
      this.saveBo.contactDescribe = null;
    }
  }
  GetContactType() {
    let params = new URLSearchParams();
    params.append("ListCode", "SESSIONCONTACTTYPE");
    this.CSService.getServiceBasedLovType(params).subscribe((data: any) => {
      this.ContactList = data;
    })
  }

  GetClientPmi() {
    let params = new URLSearchParams();
    params.append("id", this.saveBo?.clientId);
    let url = ""
    if (this.global.OnboardType == "CLIENT") {
      url = "api/ConsultationSession/GetClientPMI?";
    }
    else {
      url = "api/Client/GetClientPMI?";
    }
    this.CSService.getclientpmi(params, url).subscribe((data: any) => {
      this.saveBo.pMI = data.Value;
    })
  }
  onClientChange() {
    if(this.isEmployeeDisabled!=true)
    {
    let params = new URLSearchParams();
    params.append("ClientId", this.saveBo.clientId);

    let url = "api/EmployeeClientMapping/getLastMappedActEmployee?";

    this.http.get<any[]>(url + params.toString()).subscribe(
      (data: any) => {

        if (!!data) {
          this.UserDropDownList.push(data)
          this.saveBo.employeeId = this.UserDropDownList.find(p=>p.key == data.key).key;
        } else {
          this.saveBo.employeeId = null;
        }
        this.isEmployeeDisabled=false;
      },
      (error) => {
        console.error("Error fetching employee data:", error);
      }
    );
  }
  }
  // Service Type
  async GetServiceType(): Promise<void> {
    return new Promise((resolve, reject) => {
      // if (this.saveBo.clientId != null && this.saveBo.clientId != undefined) {
        let params = new URLSearchParams();
        // params.append("ClientId", this.saveBo.clientId)
        this.CSService.getServiceValues(params).subscribe((data: any) => {
          this.ServiceList = data;
          console.log( this.saveBo.typeofServiceId," this.saveBo.typeofServiceId");

          resolve(data);
          if (this.ServiceList.length == 0) {
            this.saveBo.typeofServiceId = null;
          }
          else{
            this.saveBo.typeofServiceId= this.saveBo.typeofServiceId;
          }
        })
      // } else {
        resolve();
        this.ServiceList = [];
        this.saveBo.typeofServiceId = null;
      // }
    });
  }
  // Service Based Lov Type
  GetServiceSetup() {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("ListCode", "SERVICESETUPANDANNUALCFSSORIENTATION");
      this.CSService.getServiceBasedLovType(params).subscribe((data: any) => {
        data?.forEach((element) => {
          element.engagementId= "00000000-0000-0000-0000-000000000000",
          element.serviceTypeId= null,
          element.serviceListLovid= element.id,
          element.isCheck= false,
          element.description= "",
          element.lovName= element?.lovName
      });

        // data = [...data].sort((a, b) =>
        //   a.lovName?.localeCompare(b?.lovName)
        // );
      this.ServiceSetupList=data
      this.SSSlist = JSON.parse(JSON.stringify(data));
      })
    });
  }
  getQualityAssuranceSupport() {
    let params = new URLSearchParams();
    params.append("ListCode", "QUALITYASSURANCESUPPORT");
    this.CSService.getServiceBasedLovType(params).subscribe((data: any) => {
      data?.forEach((element) => {
        element.engagementId= "00000000-0000-0000-0000-000000000000",
        element.serviceTypeId= null,
        element.serviceListLovid= element.id,
        element.isCheck= false,
        element.description= "",
        element.lovName= element?.lovName
    });
    // data = [...data].sort((a, b) =>
    //   a?.lovName.localeCompare(b?.lovName)
    // );
    this.QualityAssuranceList=data
    this.OASlist = JSON.parse(JSON.stringify(data));
    })
  }
  GetOngoing() {
    let params = new URLSearchParams();
    params.append("ListCode", "ONGOINGCONSULTATIONANDSKILLDEVELOPMENT");
    this.CSService.getServiceBasedLovType(params).subscribe((data: any) => {
      data?.forEach((element) => {
        element.engagementId= "00000000-0000-0000-0000-000000000000",
        element.serviceTypeId= null,
        element.serviceListLovid= element.id,
        element.isCheck= false,
        element.description= "",
        element.lovName= element?.lovName
    });
    // data = [...data].sort((a, b) =>
    //   a?.lovName.localeCompare(b?.lovName)
    // );
    this.OngoingList=data
    this.Olist = JSON.parse(JSON.stringify(data));
    })
  }
  async getServiceBasedLovValues() {
    this.isSSL = false; this.isQAL = false; this.isOngoing = false;
    let serviceDetails = this.ServiceList?.filter(a => a.id == this.saveBo.typeofServiceId)[0];
    if (serviceDetails?.serviceCode?.includes("Orientation")) {
      this.isSSL = true
    }
    else if (serviceDetails?.serviceCode?.includes("QA")) {
      this.isQAL = true
    }
    else if (serviceDetails?.serviceCode?.includes("Ongoing")) {
      this.isOngoing = true
    }

    console.log(this.isOngoing,"isOn");
    console.log(this.isQAL,"isQAL");
    console.log(this.isSSL,"isSSL");

    if (
      new Date(this.StartDate).getTime() <= new Date(this.EndDate).getTime()
    ) {
      let start = new Date(this.StartDate).getTime();
      let end = new Date(this.EndDate).getTime();
      let diff = end - start;

      var hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * 1000 * 60 * 60;
      var minutes = Math.floor(diff / 1000 / 60);
      if (minutes <= 7) {
        minutes = 0;
      } else if (minutes <= 22) {
        minutes = 25;
      } else if (minutes <= 37) {
        minutes = 50;
      } else if (minutes <= 52) {
        minutes = 75;
      } else {
        minutes = 0;
        hours += 1;
      }
      let durationHours = hours + "." + minutes;
      this.duration = hours + "." + minutes;
      this.saveBo.duration = parseFloat(durationHours)

    }
  }
  SaveManualEngagement() {
    let saveSessionBo: EngagementSaveBO = JSON.parse(JSON.stringify(this.saveBo));
    saveSessionBo.clientId = this.saveBo.clientId
    saveSessionBo.employeeId = this.saveBo.employeeId
    saveSessionBo.callStartDate = this.saveBo.id != null && this.saveBo.id != undefined && this.saveBo.id != '00000000-0000-0000-0000-000000000000' ? this.global.getDateTimeString(this.StartDate) : this.StartDate;
    saveSessionBo.callEndDate = this.saveBo.id != null && this.saveBo.id != undefined && this.saveBo.id != '00000000-0000-0000-0000-000000000000' ? this.global.getDateTimeString(this.EndDate) : this.EndDate;
    saveSessionBo.id = this.saveBo.id;
    saveSessionBo.typeofContactId = this.saveBo.typeofContactId;
    saveSessionBo.typeofServiceId = this.saveBo.typeofServiceId;
    let sessionTypeList: any = [];
    saveSessionBo.serviceCode = this.saveBo.serviceCode
    if (this.isSSL) {
      console.log(this.ServiceSetupList,'this.ServiceSetupList');

      this.ServiceSetupList?.forEach(element => {
        element.engagementId = saveSessionBo.id
        element.serviceTypeId = this.saveBo.typeofServiceId;
        element.serviceListLovid = element.serviceListLovid
        element.isCheck = element.isCheck
        element.description =   element.description

      });
      sessionTypeList = this.ServiceSetupList;
    }
    else if (this.isQAL) {
      console.log(this.QualityAssuranceList,'this.QualityAssuranceList');

      this.QualityAssuranceList?.forEach(element => {
        element.engagementId = saveSessionBo.id
        element.serviceTypeId = this.saveBo.typeofServiceId;
        element.serviceListLovid = element.serviceListLovid
        element.isCheck = element.isCheck
        element.description =   element.description

      });
      sessionTypeList = this.QualityAssuranceList;

    }
    else if (this.isOngoing) {
      console.log(this.OngoingList,'this.OngoingList');

      this.OngoingList?.forEach(element => {
        element.engagementId = saveSessionBo.id
        element.serviceTypeId = this.saveBo.typeofServiceId;
        element.serviceListLovid = element.serviceListLovid
        element.isCheck = element.isCheck
        element.description =   element.description


      });
      sessionTypeList = this.OngoingList;
    }
    saveSessionBo.sessionTypeList = sessionTypeList;
    // return
    this.CSService.SaveManualEngagement(saveSessionBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (saveSessionBo.id == null || saveSessionBo.id == undefined || saveSessionBo.id == "") {
        this.toastrService.success("Session saved Successfully!");
      }
      else {
        this.toastrService.success("Session Updated Successfully!");
      }
      // this.clearEngagement();
      this.getCSListFilter();
      document.getElementById("openSessionModal").click();
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
      })
  }

// Add this method to get logged-in employee ID
GetLoggedInEmployeeId() {
  if (this.global?.agencyCode != "SUPERADMIN" && this.global?.OnboardType != "ONBOARDING") {
    // Get the logged-in employee ID from your global service or local storage
    // Adjust this based on where you store the logged-in user info
    this.loggedInEmployeeId = this.global?.employeeId; // or wherever you store it
    return this.loggedInEmployeeId;
  }
  return null;
}

  AddSession() {
    this.clearEngagement();
       // **NEW: Set logged-in employee as default**
  const loggedInEmpId = this.GetLoggedInEmployeeId();
  console.log(loggedInEmpId);
  console.log(this.UserDropDownList);
  
  if (loggedInEmpId) {
    // Check if the logged-in employee exists in the dropdown list
    const employeeExists = this.UserDropDownList?.some(emp => emp.Key === loggedInEmpId);
    if (employeeExists) {
      this.saveBo.employeeId = loggedInEmpId;
      this.isEmployeeDisabled=true;
    }
  }
    if (this.global?.OnboardType == "CLIENT") {
      this.saveBo.clientId = this.global?.cfssLoginEntityId;
    }

    if (this.global.OnboardType == "CLIENT") {
      this.saveBo.clientId = this.ClientList?.filter(cli => cli.Key == this.global.cfssLoginEntityId)[0]?.Key;
 //     this.GetServiceType();
      this.GetClientPmi()
      this.onClientChange()
    }
    if (this.csform?.ClientId != null && this.csform?.ClientId != undefined && this.csform?.ClientId != "") {
      this.saveBo.clientId = this.ClientList?.filter(cli => cli.Key == this.csform.ClientId)[0]?.Key;
      this.checkEligibility()
    //  this.GetServiceType();
      this.GetClientPmi()
      this.onClientChange()
    }
  //     // **NEW: Set logged-in employee as default**
  // const loggedInEmpId = this.GetLoggedInEmployeeId();
  // console.log(loggedInEmpId);
  // console.log(this.UserDropDownList);

  // if (loggedInEmpId) {
  //   // Check if the logged-in employee exists in the dropdown list
  //   const employeeExists = this.UserDropDownList?.some(emp => emp.Key === loggedInEmpId);
  //   if (employeeExists) {
  //     alert("employeeExists")
  //     this.saveBo.employeeId = loggedInEmpId;
  //     this.isEmployeeDisabled=true;
  //   }
  // }
  }

  GetSpecificEngagementDetails(data) {
    this.saveBo = new EngagementSaveBO();
    this.duration = null;
    this.isContactOtherDes = false;
    this.isOngoing = false;
    this.isQAL = false;
    this.isSSL = false;
    let params = new URLSearchParams();
    params.append("Id", data.id);
    this.CSService.GetSpecificEngagementDetails(params).subscribe(async (data: any) => {
      this.saveBo = data[0];
      console.log(this.saveBo,"saveBOO===========");

      this.StartDate = data[0]?.callStartDate  != null && data[0]?.callStartDate  != undefined ?
        this.datepipe.transform(data[0]?.callStartDate , "yyyy-MM-dd HH:mm:ss") : "";
      this.EndDate = data[0]?.callEndDate  != null && data[0]?.callEndDate  != undefined ?
        this.datepipe.transform(data[0]?.callEndDate , "yyyy-MM-dd HH:mm:ss") : "";
      this.SessionDate = this.StartDate != null ? this.datepipe.transform(this.StartDate, "MM/dd/yyyy") : null;
      this.duration = this.saveBo.duration;
      this.saveBo.pMI = data[0]?.pmi;

      if(this.saveBo.clientId!=null && this.saveBo.clientId!=undefined && this.saveBo.clientId!=''){this.GetClientPmi()}

      // await this.GetServiceType().then(async (data) => {
        if (this.saveBo.contactDescribe != null && this.saveBo.contactDescribe != undefined && this.saveBo.contactDescribe != '') {
          this.isContactOtherDes = true;
        }
        else {
          this.isContactOtherDes = false;
        }

        console.log(this.saveBo.contactDescribe,"this.saveBo.contactDescribe");
        console.log(this.saveBo.sessionTypeList,"this.saveBo.sessionTypeList");


        this.getServiceBasedLovValues();
        if (this.isSSL && this.saveBo.sessionTypeList.length > 0) {
          this.saveBo.sessionTypeList.forEach(items =>{
            this.ServiceSetupList.forEach(list =>{
              if(list.serviceListLovid == items.serviceListLovid)
              {
                list.isCheck = true;
                list.engagementId = items.engagementId;
                list.serviceTypeId = items.serviceTypeId;
                list.description = items.description;
              }
            })
          })
        }
        else if (this.isQAL && this.saveBo.sessionTypeList.length > 0) {
          this.saveBo.sessionTypeList.forEach(items =>{
            this.QualityAssuranceList.forEach(list =>{
              if(list.serviceListLovid == items.serviceListLovid)
              {
                list.isCheck = true;
                list.engagementId = items.engagementId;
                list.serviceTypeId = items.serviceTypeId;
                list.description = items.description;
              }
            })
          })
        }
        else if (this.isOngoing && this.saveBo.sessionTypeList.length > 0) {
          // this.OngoingList = this.saveBo.sessionTypeList
          this.saveBo.sessionTypeList.forEach(items =>{
            this.OngoingList.forEach(list =>{
              if(list.serviceListLovid == items.serviceListLovid)
              {
                list.isCheck = true;
                list.engagementId = items.engagementId;
                list.serviceTypeId = items.serviceTypeId;
                list.description = items.description;
              }
            })
          })
        }
        console.log(this.OngoingList , this.QualityAssuranceList , this.ServiceSetupList)
        this.checkEligibility();
        this.showAuthPopup();

    } ,(err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
isDataLoaded: boolean = false;
viewconsultationsession(data) {
    this.isViewMode = true;
    this.currentViewData = data;
    this.isDataLoaded = false;

    // Clear previous state
    this.saveBo = new EngagementSaveBO();
    this.duration = null;
    this.isContactOtherDes = false;
    this.isOngoing = false;
    this.isQAL = false;
    this.isSSL = false;

    let params = new URLSearchParams();
    params.append("Id", data.id);

    this.CSService.GetSpecificEngagementDetails(params).subscribe(async (responseData: any) => {
        this.saveBo = responseData[0];
        this.checktypeofcontact = responseData[0].typeofContactId;
        this.duration = responseData[0]?.duration;
        this.saveBo.pMI = responseData[0]?.pmi;
        this.saveBo.userName = responseData[0]?.userName;
        this.saveBo.typeofServiceId = responseData[0]?.typeofServiceId;

        // Handle dates
        let CSD = responseData[0]?.callStartDate + "+00:00";
        let CED = responseData[0]?.callEndDate + "+00:00";
        let convertedCSD = (CSD != null && CSD != undefined) ? new Date(CSD.toLocaleString()) : null;
        let convertedCED = (CED != null && CED != undefined) ? new Date(CED.toLocaleString()) : null;

        this.StartDate = convertedCSD != null && convertedCSD != undefined ?
            this.datepipe.transform(convertedCSD, "yyyy-MM-dd HH:mm:ss") : "";
        this.EndDate = convertedCED != null && convertedCED != undefined ?
            this.datepipe.transform(convertedCED, "yyyy-MM-dd HH:mm:ss") : "";
        this.SessionDate = this.StartDate != null ? this.datepipe.transform(this.StartDate, "MM/dd/yyyy") : null;

        this.saveBo.contactDescribe = responseData[0]?.contactDescribe;
        this.saveBo.sessionTypeList = responseData[0]?.sessionTypeList;

        // Set contact other description flag
        if (responseData[0]?.contactDescribe != null &&
            responseData[0]?.contactDescribe != undefined &&
            responseData[0]?.contactDescribe != '') {
            this.isContactOtherDes = true;
        }

        // Reset all lists to original state first
        this.ServiceSetupList = JSON.parse(JSON.stringify(this.SSSlist));
        this.QualityAssuranceList = JSON.parse(JSON.stringify(this.OASlist));
        this.OngoingList = JSON.parse(JSON.stringify(this.Olist));

        // Determine service type and set flags
        let serviceDetails = this.ServiceList?.filter(a => a.id == this.saveBo.typeofServiceId)[0];
        if (serviceDetails?.serviceCode?.includes("Orientation")) {
            this.isSSL = true;
            this.isQAL = false;
            this.isOngoing = false;
        } else if (serviceDetails?.serviceCode?.includes("QA")) {
            this.isQAL = true;
            this.isSSL = false;
            this.isOngoing = false;
        } else if (serviceDetails?.serviceCode?.includes("Ongoing")) {
            this.isOngoing = true;
            this.isSSL = false;
            this.isQAL = false;
        }

        // Map the saved data to checkboxes based on service type
        if (this.isSSL && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items => {
                this.ServiceSetupList.forEach(list => {
                    if (list.serviceListLovid == items.serviceListLovid || list.id == items.serviceListLovid) {
                        list.isCheck = true;
                        list.engagementId = items.engagementId;
                        list.serviceTypeId = items.serviceTypeId;
                        list.description = items.description;
                    }
                });
            });
        } else if (this.isQAL && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items => {
                this.QualityAssuranceList.forEach(list => {
                    if (list.serviceListLovid == items.serviceListLovid || list.id == items.serviceListLovid) {
                        list.isCheck = true;
                        list.engagementId = items.engagementId;
                        list.serviceTypeId = items.serviceTypeId;
                        list.description = items.description;
                    }
                });
            });
        } else if (this.isOngoing && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items => {
                this.OngoingList.forEach(list => {
                    if (list.serviceListLovid == items.serviceListLovid || list.id == items.serviceListLovid) {
                        list.isCheck = true;
                        list.engagementId = items.engagementId;
                        list.serviceTypeId = items.serviceTypeId;
                        list.description = items.description;
                    }
                });
            });
        }

        // Set data loaded flag and trigger change detection
        this.isDataLoaded = true;
        this.cdRef.detectChanges();

        // Open the view modal after a short delay to ensure DOM is updated
        setTimeout(() => {
            document.getElementById('openViewPdfModal').click();
        }, 200);

    }, (error) => {
        console.error('Error loading session details:', error);
        this.isDataLoaded = true;
    });
}
  DownloadSessionForm(data) {
    // this.saveBo = new EngagementSaveBO();
    // this.duration = null;
    let params = new URLSearchParams();
    this.isContactOtherDes = false;
    this.isOngoing = false;
    this.isQAL = false;
    this.isSSL = false;
    params.append("Id", data.id);
    this.CSService.GetSpecificEngagementDetails(params).subscribe(async (data: any) => {
      // this.saveBo = new EngagementSaveBO();
      this.saveBo.pMI="";
      this.saveBo = data[0];
      this.checktypeofcontact =  data[0].typeofContactId;
      this.duration =data[0]?.duration;
      this.saveBo.pMI = data[0]?.pmi;
      this.saveBo.userName = data[0]?.userName;
      this.saveBo.typeofServiceId= data[0]?.typeofServiceId;
      console.log( this.saveBo.userName," this.saveBo.userName = data[0]?.userName;");

      let CSD = data[0]?.callStartDate + "+00:00";
      let CED = data[0]?.callEndDate + "+00:00";
      let convertedCSD = (CSD != null && CSD != undefined) ? new Date(CSD.toLocaleString()) : null;
      let convertedCED = (CED != null && CED != undefined) ? new Date(CED.toLocaleString()) : null;
      this.StartDate = convertedCSD != null && convertedCSD != undefined ?
        this.datepipe.transform(convertedCSD, "yyyy-MM-dd HH:mm:ss") : "";
      this.EndDate = convertedCED != null && convertedCED != undefined ?
        this.datepipe.transform(convertedCED, "yyyy-MM-dd HH:mm:ss") : "";
      this.SessionDate = this.StartDate != null ? this.datepipe.transform(this.StartDate, "MM/dd/yyyy") : null;
      this.saveBo.contactDescribe = data[0]?.contactDescribe

      this.saveBo.sessionTypeList= data[0]?.sessionTypeList;


      if (data[0]?.contactDescribe != null && data[0]?.contactDescribe != undefined && data[0]?.contactDescribe != '') {
        this.isContactOtherDes = true;
      }
      else {
        this.isContactOtherDes = false;
      }
      // await this.GetServiceType().then(async (data) => {

        await this.getServiceBasedLovValues().then(async (data) => {
            this.GetOngoing();
            this.getQualityAssuranceSupport();
            this.GetServiceSetup();
          if (this.isSSL && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items =>{
              this.ServiceSetupList.forEach(list =>{
                if(list.serviceListLovid == items.serviceListLovid)
                {
                  list.isCheck = true;
                  list.engagementId = items.engagementId;
                  list.serviceTypeId = items.serviceTypeId;
                  list.description = items.description;
                }
              })
            })
            this.QualityAssuranceList=[]
            this.OngoingList=[]
           // this.GetOngoing();
            //this.getQualityAssuranceSupport();
            this.isQAL = false;
            this.isOngoing = false;
            this.cdRef.detectChanges();
            if (this.isViewMode) {
            // For view mode - open the modal
            setTimeout(() => {
                document.getElementById('openViewPdfModal').click();
            }, 500);
        } else {
            // For download mode
            Promise.resolve().then(() => {
               this.DownloadPDF();
             });
        }

          }
          else if (this.isQAL && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items =>{
              this.QualityAssuranceList.forEach(list =>{
                if(list.serviceListLovid == items.serviceListLovid)
                {
                  list.isCheck = true;
                  list.engagementId = items.engagementId;
                  list.serviceTypeId = items.serviceTypeId;
                  list.description = items.description;
                }
              })
            })
            this.ServiceSetupList=[]
            this.OngoingList=[]
           // this.GetOngoing();
            this.GetServiceSetup();

            this.isSSL = false;
            this.isOngoing = false;
            this.cdRef.detectChanges();
             if (this.isViewMode) {
            // For view mode - open the modal
            setTimeout(() => {
                document.getElementById('openViewPdfModal').click();
            }, 500);
        } else {
            // For download mode
             Promise.resolve().then(() => {
               this.DownloadPDF();
             });
        }
          }
          else if (this.isOngoing && this.saveBo.sessionTypeList.length > 0) {
            this.saveBo.sessionTypeList.forEach(items =>{
              this.OngoingList.forEach(list =>{
                if(list.serviceListLovid == items.serviceListLovid)
                {
                  list.isCheck = true;
                  list.engagementId = items.engagementId;
                  list.serviceTypeId = items.serviceTypeId;
                  list.description = items.description;
                }
              })
            })
            this.ServiceSetupList=[]
            this.QualityAssuranceList=[]
            this.getQualityAssuranceSupport();
            this.GetServiceSetup();
            // this.ServiceSetupList= this.ServiceSetupList
            // this.QualityAssuranceList= this.QualityAssuranceList
            this.isSSL = false;
            this.isQAL = false;
            this.cdRef.detectChanges();
           if (this.isViewMode) {
            // For view mode - open the modal
            setTimeout(() => {
                document.getElementById('openViewPdfModal').click();
            }, 500);
        } else {
            // For download mode
             Promise.resolve().then(() => {
               this.DownloadPDF();
             });

        }
          }
             // Handle view vs download
             this.isDataLoaded = true;

      //  })

      })


    })
  }
closeViewPdf() {
    this.isViewMode = false;
    this.currentViewData = null;
    // Reset any necessary state
    this.clearEngagement();
}

  DownloadPDF(){
    (this.PdfList.A4 = true),
    (this.PdfList.portrait = true),
    (this.PdfList.keepTogether = ".prevent-split"),
    (this.PdfList.scale = 0.8),
    (this.PdfList.height = 100),
    (this.PdfList.margin = {
      left: "-10px",
      top: "1cm",
      right: "0cm",
      bottom: "1cm",
    });
  this.PdfList.padding = { bottom: "50px" };
  this.PdfList.forcePageBreak = ".page-header";
  this.PdfList.saveAs(
    "ConsultationServices" +
    new Date().toLocaleDateString() +
    "-" +
    new Date().toLocaleTimeString()
  );
  setTimeout(() => {
    this.viewpdf=false;
  }, 1000);
}

  showAuthPopup(){
    console.log(this.saveBo.clientId , this.StartDate ,this.EndDate )
    if(this.saveBo.clientId == null || this.saveBo.clientId == "" || this.saveBo.clientId == '00000000-0000-0000-0000-000000000000' || this.StartDate == null || this.StartDate == "" || this.StartDate == undefined || this.EndDate == null || this.EndDate == "" || this.EndDate == undefined  )
    {
      return;
    }
    let url = "api/Client/GetClientHasAuth";
    this.popupbo.clientId = this.saveBo.clientId
    this.popupbo.startDate = this.saveBo.id != null && this.saveBo.id != undefined && this.saveBo.id != '00000000-0000-0000-0000-000000000000' ? this.global.getDateTimeString(this.StartDate) : this.StartDate;
    this.popupbo.endDate = this.saveBo.id != null && this.saveBo.id != undefined && this.saveBo.id != '00000000-0000-0000-0000-000000000000' ? this.global.getDateTimeString(this.EndDate) : this.EndDate;
    this.CommonApi.saveorUpdateFunctionwithResponseTypeJson(this.popupbo , url).subscribe((data : any)=>{
     this.popupmsg = data?.authValidation;
     if(data?.authValidation == '' || data?.authValidation == null || data?.authValidation == undefined )
      return;
    const sdate: HTMLInputElement | null = document.getElementById('endDatePicker') as HTMLInputElement;
    const edate: HTMLInputElement | null = document.getElementById('startDatePicker') as HTMLInputElement;
    if (sdate) {
      sdate.blur();
    }
    if (edate) {
      edate.blur();
    }
      document.getElementById("openSessionWarning").click();
    },
  (error : any)=>{

  })
  }

    checkValidation() {
      if(this.saveBo.clientId!=undefined&&this.saveBo.clientId!=null&&this.saveBo.clientId!="00000000-0000-0000-0000-000000000000"&&this.StartDate!=undefined&&this.StartDate!=null&&this.StartDate!=''&&this.EndDate!=null&&this.EndDate!=undefined&&this.EndDate!=''){
      let url = "api/Client/CheckOneSession";
      this.ClientAuthforSessionBO.id=(this.saveBo.id!=undefined&&this.saveBo.id!=null&&this.saveBo.id!="00000000-0000-0000-0000-000000000000")?this.saveBo.id:"00000000-0000-0000-0000-000000000000";
     this.ClientAuthforSessionBO.clientId=this.saveBo.clientId;
     this.ClientAuthforSessionBO.startDate=(this.StartDate!=undefined&&this.StartDate!=''&&this.StartDate!=null)?this.global.getDateTimeString(this.StartDate):null;
     this.ClientAuthforSessionBO.endDate=(this.EndDate!=undefined&&this.EndDate!=''&&this.EndDate!=null)?this.global.getDateTimeString(this.EndDate):null;
      this.CommonApi.saveorUpdateFunctionwithResponseTypeJson(this.ClientAuthforSessionBO,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
        if (data) {
          //====================== sucess message =============
       this.showAuthPopup()
        }
      }, (err: any) => {
        this.toastrService.error(err)
      return
      }
      )
      }

    }
      //......................................exportCaseWithPaginationCsv.....................................................
    exportCaseWithPaginationCsv() {
        if (this.global.OnboardType == "CLIENT") {
      this.CSBO.clientId = this.global.cfssLoginEntityId;
    }
    else if (this.csform != null) {
      this.CSBO.clientId = this.csform.ClientId;
    }
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.CSBO.startDate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeString(SDate) : null

    this.CSBO.endDate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeString(EDate) : null
        let url = "api/Engagement/exportSessionWithPaginationCsv";
        this.CommonApi.saveorUpdateFunctionFileSaver(this.CSBO ,url, "ConsultationServiceReport.csv");

    }
    //...........................................exportCaseCsv................................................................
    exportCaseCsv() {
        if (this.global.OnboardType == "CLIENT") {
      this.CSBO.clientId = this.global.cfssLoginEntityId;
    }
    else if (this.csform != null) {
      this.CSBO.clientId = this.csform.ClientId;
    }
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.CSBO.startDate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeString(SDate) : null

    this.CSBO.endDate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeString(EDate) : null

        let url = "api/Engagement/exportSessionAllCsv";
        this.CommonApi.saveorUpdateFunctionFileSaver(this.CSBO, url, "ConsultationServiceReport.csv")

    }

   clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridCSessionGrid', expectedColumns: this.ConsultSessionTotalColumns },
    ];

    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
checkEligibility() {
  if (this.saveBo?.clientId && 
      this.saveBo.clientId !== "00000000-0000-0000-0000-000000000000") {
    this.clientId = this.saveBo.clientId;
  } 
  // Otherwise use global clientId (external page context)
  else if (this.global?.clientId && 
           this.global.clientId !== "00000000-0000-0000-0000-000000000000") {
    this.clientId = this.global.clientId;
  }      
     let params = new URLSearchParams();
       params.append("ClientId", this.clientId);
      let url = "api/Client/GetClientHasEligibility?";
      this.CommonApi.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      
       if (data == false) {
          // Client is NOT eligible
          this.isClientEligible = false;
          this.showEligibilityMessage = true;
        } else {
          // Client IS eligible
          this.isClientEligible = true;
          this.showEligibilityMessage = false;
          
        }
      }, (err: any) => {
        this.toastrService.error(err)
      return
      }
      )
      
      
    }

      filepermissionget() {
        let params = new URLSearchParams();
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
        params.append("pagecode", "AgreementTemplate");
          params.append("roleId", this.global?.roleId);
          params.append("agencyId", this.global?.globalAgencyId)
        this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          if (data != null) {
            this.fp = data;
          }
          else {
            this.fp = new functionpermission();
          }
        },
          (err: HttpErrorResponse) => {
            this.fp = new functionpermission();
          })
      }

     getpermission() {
          let params = new URLSearchParams();
          params.append("pagecode", "CONSULTATIONSESSION");
          params.append("roleId", this.global?.roleId);
          params.append("agencyId", this.global?.globalAgencyId)
          let url = "api/FunctionPermission/getfunctionpermissionemployee?";
          this.CommonApi.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            if (data != null) {
              this.fp = data?.isEmployeeEnable;
            }
            else {
              this.fp = new functionpermission();
            }
            console.log( this.fp)
          },
            (err: HttpErrorResponse) => {
              this.fp = new functionpermission();
            })
        }
      
}
